import CloseIcon from '../../../assets/icons/close.svg?react';
import { useUpdateSetUp, useDeleteSetUp } from '../../../hooks/queries/setUpQueries';
import { useAuth } from '../../../hooks/useAuth';
import { useState } from 'react';
const SystemSetUpConfirmModal = ({ data, value, onClose, mode }) => {
  const { user } = useAuth();
  const updateSetUp = useUpdateSetUp();
  const deleteSetUp = useDeleteSetUp();
  const [isPending, setIsPending] = useState(false);
  const handleConfirm = async () => {
    setIsPending(true);
    try {
        if (mode === 'edit') {
          await updateSetUp.mutateAsync({
          group: data.Group,
          key: data.Key,
          value: value,
          updatedBy: user?.UserSysId || '',
          });
        } else if (mode === 'delete') {
          await deleteSetUp.mutateAsync({
          group: data.Group,
          key: data.Key,
          valueType: data.ValueType,
          description: data.Description,
          });
        }
        onClose();
    } catch (error) {
      console.error('시스템 설정값 수정 실패:', error);
    } 
    finally {
      setIsPending(false);
    }
  }
  
  return (
    <div className="modal-background" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{mode === 'edit' ? '시스템 설정값 수정 확인' : '시스템 설정 삭제 확인'}</h3>
          <button 
            className="close-btn"
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content">
          <p className="my-10 text-b2-400 text-gray-700">{mode === 'edit' ? '시스템 설정값을 수정하시겠습니까?' : '시스템 설정을 삭제하시겠습니까?'}</p>
          <table className="gray-table">
            <tr>
              <th>Key</th>
              <td>{data.Key}</td>
            </tr>
            <tr>
              <th>Value</th>
              <td>{value}</td>
            </tr>
            <tr>
              <th>Description</th>
              <td>{data.Description}</td>
            </tr>
          </table>
        </div>
        <div className="modal-footer">
          <button className="btn big-btn btn-primary" onClick={handleConfirm}>{ isPending ? '수정 중...' : '수정'}</button>
          <button className="btn big-btn btn-style-5" onClick={onClose}>취소</button>
        </div>
      </div>
    </div>
  )
}

export default SystemSetUpConfirmModal